import React, { useState, useEffect, useRef, useContext } from "react";
import { ReactComponent as JavascriptIcon } from "../images/javascript.svg";
import { ReactComponent as CommunityIcon } from "../images/community.svg";
import { ReactComponent as ProjecstIcon } from "../images/projects.svg";
import { ReactComponent as HospitalIcon } from "../images/hospital.svg";
import { ReactComponent as Covid_19Icon } from "../images/covid_19.svg";
import { ReactComponent as FeedbackIcon } from "../images/feedback.svg";
import { ReactComponent as StudentIcon } from "../images/student.svg";
import { ReactComponent as AbouttIcon } from "../images/about_me.svg";
import { ReactComponent as ChevronIcon } from "../images/chevron.svg";
import { fade, makeStyles, useTheme } from "@material-ui/core/styles";
import { ReactComponent as LessonIcon } from "../images/lesson.svg";
import { StateContext } from "../reducers_component/StateProvider";
import { ReactComponent as LogoutIcon } from "../images/logout.svg";
import { ReactComponent as ReactIcon } from "../images/react.svg";
import { ReactComponent as ArrowIcon } from "../images/arrow.svg";
import NotificationsIcon from "@material-ui/icons/Notifications";
import { ReactComponent as HtmlIcon } from "../images/html.svg";
import { ReactComponent as MysqlIcon } from "../images/mysql.svg";
import { ReactComponent as CaretIcon } from "../images/caret.svg";
import { ReactComponent as BoltIcon } from "../images/bolt.svg";
import { ReactComponent as CssIcon } from "../images/css.svg";
import { ReactComponent as OrgIcon } from "../images/org.svg";
import { ReactComponent as LangIcon } from "../images/lan.svg";
import { ReactComponent as RefIcon } from "../images/ref.svg";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { ReactComponent as CogIcon } from "../images/cog.svg";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { CSSTransition } from "react-transition-group";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import { Link, useHistory } from "react-router-dom";
import InputBase from "@material-ui/core/InputBase";
import MoreIcon from "@material-ui/icons/MoreVert";
import SearchIcon from "@material-ui/icons/Search";
import MenuItem from "@material-ui/core/MenuItem";
import CloseIcon from "@material-ui/icons/Close";
import Divider from "@material-ui/core/Divider";
import Toolbar from "@material-ui/core/Toolbar";
import MenuIcon from "@material-ui/icons/Menu";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Badge from "@material-ui/core/Badge";
import { Avatar } from "@material-ui/core";
import Menu from "@material-ui/core/Menu";
import { auth, db } from "../firebase";
import { Text,tid  } from "../containers/Language";
import logs from "../images/ref.png";
import "../Css/HomeHeader.css";
import clsx from "clsx";
import DarkMode from "./DarkMode";
import { Helmet } from 'react-helmet';

import { languageOptions } from "../languages";
import { LanguageContext } from "../containers/Language";

const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
    position: "static",
    top: "0",
    background: "green",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    color: "white",
    textDecoration: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
      color: "white",
      textDecoration: "none",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },

  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },

  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#1a3957",
    color: "white",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    backgroundColor: "#1a3957",
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },

  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
}));

export default function PrimarySearchAppBar({ username, user, photoURL }) {
  const history = useHistory("");
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const { notificationState } = useContext(StateContext);
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [activeMenu, setActiveMenu] = useState("main");
  const [menuHeight, setMenuHeight] = useState(null);
  const dropdownRef = useRef(null);
  const { userLanguage, userLanguageChange } = useContext(LanguageContext);

  // set selected language by calling context method
  const handleLanguageChange = (e) => userLanguageChange(e.target.value);

  // dispatch({ type: "ADD_TO_NOTIFICATIONS", item: "some notification" })

  useEffect(() => {
    setMenuHeight(dropdownRef.current?.firstChild.offsetHeight);
  }, []);

  function calcHeight(el) {
    const height = el.offsetHeight;
    setMenuHeight(height);
  }

  function DropdownItem(props) {
    return (
      <div
        href="#"
        className="menu-item"
        onClick={() => props.goToMenu && setActiveMenu(props.goToMenu)}
      >
        <span className="icon-button">{props.leftIcon}</span>
        {props.children}
        <span className="icon-right">{props.rightIcon}</span>
      </div>
    );
  }

  const theme = useTheme();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };
  if (user === false) {
    history.push("/Welcome_to_the_world_com_application");
  }

  const logout = () => {
    if (user) {
      auth.signOut();
      history.push("/login");
    }
  };

  const renderNotifications = () => {
    if (notificationsOpen) {
      setNotificationsOpen(false);
      document
        .getElementsByClassName("dropdown-content12")[0]
        .classList.remove("block");
    } else {
      setNotificationsOpen(true);
      // setProfileDown(false);
      document
        .getElementsByClassName("dropdown-content12")[0]
        .classList.add("block");
    }
  };

  useEffect(() => {
    db.collection("users").onSnapshot((snapshot) => {
      setUsers(snapshot.docs.map((doc) => doc.data()));
    });

    if (users !== undefined) {
      const finalUsers = users.filter((user) => {
        return (
          user.displayName.toLowerCase().indexOf(searchTerm.toLowerCase()) !==
          -1
        );
      });

      setFilteredUsers(finalUsers);
    }
  }, [searchTerm]);

  const collapseNavbar = () => {
    document.getElementsByClassName("searchBox")[0].style.display = "none";
    document.getElementsByClassName("homeHeader__search")[0].style.display =
      "block";
    document.getElementsByClassName("dropdown-content33")[0].style.display =
      "none";
    document.getElementsByClassName("searchBox")[0].value = "";
  };
  const updateSearchResults = (e) => {
    setSearchTerm(e.target.value);
    document.getElementsByClassName("dropdown-content33")[0].style.display =
      "block";
  };

  const handleClose = () => {
    setOpen(false);
    document.getElementsByClassName("dropdown-content33")[0].style.display =
      "none";
  };

  const menuId = "primary-search-account-menu";

  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>
        <a href={`/${user?.displayName}/${user?.uid}`}>Profile</a>
      </MenuItem>

      <MenuItem onClick={logout}>
        <a href="/login">Log Out</a>
      </MenuItem>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <Avatar className="ProfileAvatar" src={user.photoURL} />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
      <MenuItem>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
        <DarkMode />
        </IconButton>
      </MenuItem>
    </Menu>
  );
  /**
   * ! Hooks for dropdownMenu
   */
  // setting section
  function DropdownMenu() {
    const [activeMenu, setActiveMenu] = useState("main");
    const [menuHeight, setMenuHeight] = useState(null);
    const dropdownRef = useRef(null);
    /**
     * ! Hooks for dropdown
     */
    useEffect(() => {
      setMenuHeight(dropdownRef.current?.firstChild.offsetHeight);
    }, []);

    function calcHeight(el) {
      const height = el.offsetHeight;
      setMenuHeight(height);
    }
    return (
      <Navbar>
        <NavItem icon={<CaretIcon />}>
          <DropdownMenu></DropdownMenu>
        </NavItem>
      </Navbar>
    );
  }

  // Navbar section
  function Navbar(props) {
    return (
      <nav className="navbar">
        <ul className="navbar-nav">{props.children}</ul>
      </nav>
    );
  }

  // navItem section

  function NavItem(props) {
    const [open, setOpen] = useState(false);
    return (
      <li className="nav-item">
        <a href="#" className="icon-button" onClick={() => setOpen(!open)}>
          {props.icon}
        </a>
        {open && props.children}
      </li>
    );
  }

  const { notifications } = notificationState;
  return (
    <div className="grow">
    <Helmet>
    <title> World-Com Home-screen </title>
  </Helmet>
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar className="menu1">
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
          <Typography className={classes.title} noWrap>
            <Link className="tititit" to="/">
              <img src={logs} alt="worldcom" className="header_logo11" />
            </Link>
          </Typography>

          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>

            <InputBase
              placeholder="Search…"
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              onChange={updateSearchResults}
              inputProps={{ "aria-label": "search" }}
            />

            <div className="dropdown-content33">
              <CloseIcon className="closeModalIcon1" onClick={handleClose} />

              <ul id="list1">
                {users !== undefined &&
                  filteredUsers.map((user1) => (
                    <li className="li3">
                      <a
                        className="a3"
                        onClick={collapseNavbar}
                        href={`/${user1?.displayName}/${user1.uid}`}
                      >
                        <Avatar className="searchAvatar" src={user1.photoURL} />
                        <h3 className="searchH33">{user1.displayName}</h3>
                      </a>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
          <div className={classes.grow} />

          <div className={classes.sectionDesktop}>
            <IconButton
              edge="end"
              // aria-label="show 17 new notifications"
              color="inherit"
              aria-controls={menuId}
              aria-haspopup="true"
            >
              <Badge
                // badgeContent={17}
                color="secondary"
              >
              <DarkMode />

              </Badge>
            </IconButton>

            <IconButton
              edge="end"
              // aria-label="show 17 new notifications"
              color="inherit"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={renderNotifications}
            >
              <Badge
                // badgeContent={17}
                color="secondary"
              >
              <NotificationsIcon />
              </Badge>
            </IconButton>
            <div className="dropdown-content12">
              <h1>Notifications</h1>
              {notifications.length === 0 ? (
                <div className="noNotifDiv">
                  <img alt="" src={user.photoURL} />
                  <p className="NoNotif">there are no active notifications</p>
                </div>
              ) : (
                console.log()
              )}

              {notifications.map((notification) => (
                <a href="!#" className="announcement">
                  <div className="optionDrop">
                    <Avatar src="" />
                    <div className="announcementInfo">
                      <h1>
                        {notification?.username}{" "}
                        <span>commented to your post.</span>
                      </h1>
                    </div>
                  </div>
                </a>
              ))}
            </div>
            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <Avatar className="ProfileAvatar" src={user.photoURL} />
            </IconButton>
          </div>
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>

      <Drawer
        variant="persistent"
        anchor="left"
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <Avatar
            onClick={handleMenuClose}
            className="ProfileAvatar1"
            src={user.photoURL}
          />
          <a href={`/${user?.displayName}/${user?.uid}`}>
            <p>{user?.displayName}</p>
          </a>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </div>
        <Divider />
        <div>
          <CSSTransition
            in={activeMenu === "main"}
            timeout={500}
            classNames="menu-primary"
            unmountOnExit
            onEnter={calcHeight}
          >
            <div className="menu">
              <DropdownItem
                leftIcon={<CogIcon />}
                rightIcon={<ChevronIcon />}
                goToMenu="More"
                href="#"
              >
                <Text tid="Home_Header_more" />
              </DropdownItem>

              <DropdownItem
                leftIcon={<LessonIcon />}
                rightIcon={<ChevronIcon />}
                goToMenu="lessons"
                href="#"
              >
                <Text tid="Home_Header_Get_courses" />
              </DropdownItem>
              <DropdownItem
                leftIcon={<CommunityIcon />}
                rightIcon={<ChevronIcon />}
                goToMenu="community"
                href="#"
              >
                <Text tid="Home_Header_Join_community" />
              </DropdownItem>
            </div>
          </CSSTransition>

          <CSSTransition
            in={activeMenu === "More"}
            timeout={500}
            classNames="menu-secondary"
            unmountOnExit
            onEnter={calcHeight}
          >
            <div className="menu">
              <DropdownItem goToMenu="main" leftIcon={<ArrowIcon />}>
                <h2 className="go_back_h2">
                  <Text tid="Home_Header_go_back" />
                </h2>
              </DropdownItem>
              <DropdownItem leftIcon={<HospitalIcon />}>
                {" "}
                <Link
                to="/Blog_1"
                className="MuiListItem-gutters1"
                >
                  {" "}
                  <Text tid="Home_Header_Information" />
                </Link>{" "}
              </DropdownItem>
              <DropdownItem leftIcon={<RefIcon />}>
                {" "}
                <Link
                to="/Refugees"
                  className="MuiListItem-gutters1"
                 
                >
                  {" "}
                  <Text tid="Home_Header_Refugees" />
                </Link>{" "}
              </DropdownItem>
  
              <DropdownItem leftIcon={<LangIcon />}>
                {" "}
                <Link className="MuiListItem-gutters1"></Link>
                <select
                  className="select_languages"
                  onChange={handleLanguageChange}
                  value={userLanguage}
                >
                  {Object.entries(languageOptions).map(([id, name]) => (
                    <option key={id} value={id}>
                      {name}
                    </option>
                  ))}
                </select>
              </DropdownItem>
  
              <DropdownItem leftIcon={<OrgIcon />}>
                {" "}
                <a
                  className="MuiListItem-gutters1"
                  onClick={() => window.open("https://eimai.org/", "_blank")}
                >
                  <Text tid="Home_Header_EIMAI_Center" />
                </a>{" "}
              </DropdownItem>
              <DropdownItem leftIcon={<Covid_19Icon />}>
                {" "}
                <a
                  className="MuiListItem-gutters1"
                  onClick={() =>
                    window.open("http://covidmediainfo.com/en", "_blank")
                  }
                >
                  <Text tid="Home_Header_covid_media" />
                </a>
              </DropdownItem>
              <DropdownItem leftIcon={<AbouttIcon />}>
                {" "}
                <a
                  className="MuiListItem-gutters1"
                  onClick={() =>
                    window.open(
                      "https://codebymurtaza.herokuapp.com/about",
                      "_blank"
                    )
                  }
                >
                  {" "}
                  <Text tid="Home_Header_About_Me" />
                </a>
              </DropdownItem>
              <DropdownItem onClick={logout} leftIcon={<LogoutIcon />}>
                {" "}
                <a className="MuiListItem-gutters1" href="/login">
                  <Text tid="Home_Header_Log_Out" />
                </a>
              </DropdownItem>
            </div>
          </CSSTransition>

          <CSSTransition
            in={activeMenu === "lessons"}
            timeout={500}
            classNames="menu-secondary"
            unmountOnExit
            onEnter={calcHeight}
          >
            <div className="menu">
              <DropdownItem goToMenu="main" leftIcon={<ArrowIcon />}>
                <h2 className="go_back_h2">
                  <Text tid="Home_Header_go_back_to_lesson" />
                </h2>
              </DropdownItem>
              <DropdownItem leftIcon={<HtmlIcon />}>
                <a
                  className="MuiListItem-gutters1"
                  onClick={() => window.open("#", "_blank")}
                >
                  HTML
                </a>
              </DropdownItem>

              <DropdownItem leftIcon={<CssIcon />}>
                <a
                  className="MuiListItem-gutters1"
                  onClick={() => window.open("#", "_blank")}
                >
                  CSS
                </a>
              </DropdownItem>
              <DropdownItem leftIcon={<JavascriptIcon />}>
                <a
                  className="MuiListItem-gutters1"
                  onClick={() => window.open("#", "_blank")}
                >
                  JavaScript
                </a>
              </DropdownItem>
              <DropdownItem leftIcon={<ReactIcon />}>
                <Link
                to="/Get-My-Free-Courses-Or-Watch-Them-On-Yout-Ube"
                  className="MuiListItem-gutters1"
                >
                  ReactJs
                </Link>
              </DropdownItem>
              <DropdownItem leftIcon={<ProjecstIcon />}>
                <Link
                to="/Next_Course"
                  className="MuiListItem-gutters1"
                >
                  <Text tid="Home_Header_projects_for_beginner" />
                </Link>
              </DropdownItem>
            </div>
          </CSSTransition>

          <CSSTransition
            in={activeMenu === "community"}
            timeout={500}
            classNames="menu-secondary"
            unmountOnExit
            onEnter={calcHeight}
          >
            <div className="menu">
              <DropdownItem goToMenu="main" leftIcon={<ArrowIcon />}>
                <h2 className="go_back_h2">
                  <Text tid="Home_Header_GO_community" />
                </h2>
              </DropdownItem>
              <DropdownItem leftIcon={<StudentIcon />}>
                <a
                  className="MuiListItem-gutters1"
                  onClick={() => window.open("#", "_blank")}
                >
                  <Text tid="Home_Header_community_students" />
                </a>
              </DropdownItem>
              <DropdownItem leftIcon={<CssIcon />}>
                <a
                  className="MuiListItem-gutters1"
                  onClick={() => window.open("#", "_blank")}
                >
                  <Text tid="Home_Header_community_mentors" />
                </a>
              </DropdownItem>
              <DropdownItem leftIcon={<JavascriptIcon />}>
                <a
                  className="MuiListItem-gutters1"
                  onClick={() => window.open("#", "_blank")}
                >
                  <Text tid="Home_Header_community_members" />
                </a>
              </DropdownItem>
              <DropdownItem leftIcon={<ProjecstIcon />}>
                <a
                  className="MuiListItem-gutters1"
                  onClick={() => window.open("#", "_blank")}
                >
                  <Text tid="Home_Header_projects_for_beginner" />
                </a>
              </DropdownItem>
            </div>
          </CSSTransition>
        </div>
      </Drawer>
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
      ></main>
      {renderMobileMenu}
      {renderMenu}
    </div>
  );
}
